import { Injectable } from '@angular/core';
import { ApiCallsService } from './api-calls.service';

import {
  Plugins,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
} from '@capacitor/core';



const { PushNotifications } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  constructor(
    private apiCallsService:ApiCallsService
  ) { }

  initPush(){
    console.log('Initializing HomePage');

    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermission().then(result => {
      if (result.granted) {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    PushNotifications.addListener(
      'registration',
      async (token: PushNotificationToken) => {
        await localStorage.setItem("token",token.value);
        // await this.apiCallsService.addDeviceToken({token:token.value});
        // await this.apiCallsService.addDeviceToToken({token:token.value,userId:JSON.parse(localStorage.getItem("trueUser")).uid,pinCode:this.apiCallsService.truePinCode});
      },
    );


    PushNotifications.addListener('registrationError', (error: any) => {
      alert('Error on registration: ' + JSON.stringify(error));
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotification) => {
      },
    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: PushNotificationActionPerformed) => {
      },
    );
  }
}
